<p class="subtitle tipo-second-color">{{ "PRIVATE.PERSONALIZATION.EDIT-DEVICE.TITLE" | translate }}</p>
<select id="device" [(ngModel)]="selectValueDisp" (change)="changeDevice()">
    <option [value]="null" hidden>{{ "PRIVATE.DOCTOR.DATA-DOCTOR.DEVICE" | translate }}</option>
    <option *ngFor= "let device of devices; let i=index" [value]="device.deviceName">{{device.deviceDescription}}</option>
    
</select>

